export class TownHall {
    public idTownHall: number;
    public townHallName: string;
    public latitude: string;
    public longitude: string;
}
